@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.beneficiary.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mifos_mobile.feature.beneficiary.generated.resources/"

internal val Res.drawable.ic_add_white_24dp: DrawableResource by lazy {
      DrawableResource("drawable:ic_add_white_24dp", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_add_white_24dp.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_beneficiary_add_48px: DrawableResource by lazy {
      DrawableResource("drawable:ic_beneficiary_add_48px", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_beneficiary_add_48px.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_error_black_24dp: DrawableResource by lazy {
      DrawableResource("drawable:ic_error_black_24dp", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_error_black_24dp.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_file_upload_black_24dp: DrawableResource by lazy {
      DrawableResource("drawable:ic_file_upload_black_24dp", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_file_upload_black_24dp.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_qrcode_scan_gray_dark: DrawableResource by lazy {
      DrawableResource("drawable:ic_qrcode_scan_gray_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_qrcode_scan_gray_dark.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_add_white_24dp", Res.drawable.ic_add_white_24dp)
  map.put("ic_beneficiary_add_48px", Res.drawable.ic_beneficiary_add_48px)
  map.put("ic_error_black_24dp", Res.drawable.ic_error_black_24dp)
  map.put("ic_file_upload_black_24dp", Res.drawable.ic_file_upload_black_24dp)
  map.put("ic_qrcode_scan_gray_dark", Res.drawable.ic_qrcode_scan_gray_dark)
}
